module.exports = __webpack_public_path__ + "img/icon_6@2x.8090a93e.svg";